import type { MediaDocType, MediaOwnerType } from '@ast-data/shared';

/**
 * The descriptions whose field list cards show a preview, and so whose gallery
 * offers the star. A Tagebuch day has no such card.
 */
export const PREVIEW_OWNER_TYPES: readonly MediaOwnerType[] = [
    'finding',
    'findingPlanum',
    'findingProfile',
    'overallDescription',
    'areaDescription',
    'sample'
];

/**
 * The picture someone chose last among these, or undefined when nobody chose
 * one. The latest choice wins rather than the only one: two devices starring
 * different pictures offline then agree without anyone clearing anything.
 */
export function chosenPreview(
    pictures: readonly MediaDocType[]
): MediaDocType | undefined {
    return pictures.reduce<MediaDocType | undefined>(
        (latest, picture) =>
            picture.previewChosenAt &&
            (!latest || picture.previewChosenAt > latest.previewChosenAt)
                ? picture
                : latest,
        undefined
    );
}

/**
 * The preview of one description: the chosen picture, else its first one.
 * `pictures` in gallery order, without the photos a sketch covers.
 */
export function previewOf(
    pictures: readonly MediaDocType[]
): MediaDocType | undefined {
    return chosenPreview(pictures) ?? pictures[0];
}
